import React from 'react';

import {
  ContractType,
  DefaultContract,
} from '../../../utils/userContract';
import { ContractState, ContractPriceType } from '../utils/ContractTypes';

const initialValues = {
  coachId: '',
  isLoadingData: false,
  isLoadingContract: false,
  coachDoc: null,
  externalCoachDoc: null,
  products: [],
  contract: { ...DefaultContract },
  previousContract: null,
  contractDoc: null,
  secondaryContractDoc: null,
  contractState: ContractState.CONFIGURATION,
  isSaving: false,
  lead: {},
  user: {},
  contractType: ContractType.USER,
  isReonboardingContract: false,
  latestContract: {},
  isAmendment: false,
  startDateMin: null,
  selectedPriceType: ContractPriceType.STANDARD,
  isPreviewTerms: false,
  leadConfigDoc: null,
  categoryPackageEntries: [],
  showCategoryCards: false,
  blockedProductIds: [],
};

const ContractModalContext = React.createContext(initialValues);

export default ContractModalContext;
export {
  initialValues,
};
